import React from "react"
import { Redirect } from "react-router-dom"

export default class Logout extends React.Component {
  state = { signedOut: false }

  componentDidMount = () => {
    this.props.logout().then(() => {
      this.setState({ signedOut: true })
    })
  }

  render = () => {
    if (this.state.signedOut) {
      return <Redirect to="/" />
    }
    return <h1>Signing Out...</h1>
  }
}
